import VideoView from './VideoView';
import URLUtils from '../../util/URLUtils';

export default class LocalVideoView extends VideoView {

    createView(model) {

        let baseUrl = model['baseUrl'];
        let libraryCatalog = model['libraryCatalog'];

        let libraryDOM = super.createView(model);

        let videoContainer = $('<div>', {
            class: 'video-container'
        }).appendTo(libraryDOM);
        
        let video = $('<video>', {
            'controls': true,
            'autoplay': true,
            css: {
                'background-color': libraryCatalog.backgroundColor
            }
        }).appendTo(videoContainer);

        $('<source>', {
            src: URLUtils.getURL(baseUrl + libraryCatalog.path),
            type: 'video/mp4'
        }).appendTo(video);

        return libraryDOM;

    }

}
